export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';

export const setLoading = (isLoading) => ({
    type: SET_LOADING,
    payload: isLoading,
});

export const clearError = () => ({
    type: CLEAR_ERROR,
});

export const setError = () => ({
    type: SET_ERROR,
});
